import { formatDateTime } from '../types';
import type { Conversation } from '../types';

interface ConversationListProps {
  conversations: Conversation[];
  currentId: string | null;
  onSelect: (id: string) => Promise<void>;
  onClose: () => void;
}

export function ConversationList({ conversations, currentId, onSelect, onClose }: ConversationListProps) {
  if (conversations.length === 0) {
    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', color: 'var(--fg-muted)', textAlign: 'center' }}>
        <p>Nenhuma conversa ainda</p>
        <p style={{ fontSize: '0.75rem', marginTop: '0.5rem' }}>Crie a primeira conversa</p>
      </div>
    );
  }

  return (
    <div style={{ flex: 1, overflow: 'auto', padding: '0.5rem' }}>
      {conversations.map(conv => (
        <button
          key={conv.id}
          onClick={() => { onSelect(conv.id); onClose(); }}
          style={{
            width: '100%',
            textAlign: 'left',
            padding: '0.75rem',
            borderRadius: 'var(--radius-sm)',
            background: conv.id === currentId ? 'var(--primary)' : 'transparent',
            color: conv.id === currentId ? 'white' : 'var(--fg)',
            border: 'none',
            marginBottom: '0.25rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem',
          }}
        >
          <span style={{ fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {conv.title || 'Sem título'}
          </span>
          <span style={{ fontSize: '0.7rem', opacity: 0.7 }}>
            {formatDateTime(conv.updatedAt)}
          </span>
        </button>
      ))}
    </div>
  );
}